import {BrowserModule, HammerModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {ModelSelectionComponent} from './ModelSelection/model-selection.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TbsaResultsComponent} from './TbsaResults/tbsa-results.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {BrushSettingsDialogComponent} from './Editor/BrushSettings/Dialog/brush-settings-dialog.component';
import {AppRoutingModule, routingComponents} from './app-routing.module';
import {DescriptionComponent} from './Authentication/Description/description.component';
import {NavbarComponent} from './Authentication/Navbar/navbar.component';
import {LoginComponent} from './Authentication/Login/login.component';
import {FooterComponent} from './Authentication/Footer/footer.component';
import {EditorNavComponent} from './Editor/EditorNav/editor-nav.component';
import {LayoutModule} from '@angular/cdk/layout';
import {NavigationComponent} from './Application/Navigation/navigation.component';
import {BrushSettingsComponent} from './Editor/BrushSettings/Card/brush-settings.component';
import {QuickviewComponent} from './Editor/Quickview/quickview.component';
import {DrawViewComponent} from './Editor/DrawView/draw-view.component';
import {ImageOverlayComponent} from './Editor/Image/ImageOverlay/image-overlay.component';
import {MeasuringComponent} from './Editor/Measuring/measuring.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {ImageWizardComponent} from './Editor/Image/ImageWizard/image-wizard.component';
import {LoadingComponent} from './Application/Loading/loading.component';
import {InfoComponent} from './Editor/Info/info.component';
import {Surface3dDesignModule} from 'surface3d-design';
import {FlexLayoutModule} from '@angular/flex-layout';
import {TargetAdaptionComponent} from './ModelSelection/target-adaption/target-adaption.component';
import {Surface3dModule} from '../../../surface3d/src/lib/surface3d.module';
import {ConfirmationDialogComponent} from './Application/ConfirmationDialog/confirmation-dialog.component';
import {PatientDialogComponent} from './ModelSelection/patient-dialog/patient-dialog.component';
import {PersistenceModule} from '../../../persistence/src/lib/persistence.module';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient): any {
    return new TranslateHttpLoader(httpClient);
}


@NgModule({
    declarations: [
        AppComponent,
        ModelSelectionComponent,
        DrawViewComponent,
        TbsaResultsComponent,
        routingComponents,
        DescriptionComponent,
        NavbarComponent,
        LoginComponent,
        FooterComponent,
        EditorNavComponent,
        NavigationComponent,
        BrushSettingsDialogComponent,
        BrushSettingsComponent,
        QuickviewComponent,
        ImageOverlayComponent,
        ImageWizardComponent,
        MeasuringComponent,
        LoadingComponent,
        InfoComponent,
        TargetAdaptionComponent,
        InfoComponent,
        ConfirmationDialogComponent,
        PatientDialogComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        Surface3dModule,
        HttpClientModule,
        LayoutModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
        Surface3dDesignModule,
        FlexLayoutModule,
        PersistenceModule,
        HammerModule,
        CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports: [],
    providers: [],
    bootstrap: [AppComponent],
    entryComponents: [
        BrushSettingsDialogComponent,
        ImageOverlayComponent,
        ConfirmationDialogComponent
    ]
})
export class AppModule {

    constructor() {
        if (!navigator.cookieEnabled) {
            // TODO change to better text
            alert('Please enable cookies in your browser settings.');
        }
    }
}
